import CourseMap from "components/CourseMap/CourseMap";
import GoogleLeaflet from "components/GoogleLeaflet/GoogleLeaflet";
import React from "react";
import styles from "styles/component/MapComponent.module.scss";
// NOTE: the old Leaflet-based heatmap (mapType==='heatmap') was retired — the new
// Three.js terrain editor lives at /heatmapeditor (see pages/HeatMapEditor).
function MapComponent(props) {
  const { mapType='rangemap'} = props;

  return (
    <>
      <figure className={styles.map_fig}>

        {mapType==='rangemap' && <GoogleLeaflet />}
        {mapType==='coursemap' && <CourseMap />}
      </figure>
    </>
  );
}
export default React.memo(MapComponent);
